export default (domain: string) => {
    if (domain.endsWith('.')) {
        return domain.substr(0, domain.length - 1)
    }
    return domain
}
